/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Layout, Button, Row, Col, Dropdown, Avatar, Typography, Menu } from 'antd';
import { CompanyLogoWhite } from 'images';
import { withRouter, useHistory } from "react-router-dom";
import UserMenu from './menu';
import auth from 'services/login/auth';
import { DownOutlined, UserOutlined } from '@ant-design/icons';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';

import './header.css';

const { Header: AntHeader } = Layout;
const { Text } = Typography;

function LoggedInLink() {
  const navigate = useHistory();
  const loggedIn = sessionStorage.getItem(LOGGEDIN_USER_DATA);
  
  if(loggedIn){
  // if(true){
  return(
    <a
				rel="noopener noreferrer"
        onClick={() => {          
          auth.signout();
        }}
        role="button"
        onKeyDown={() => {
          auth.signout();
          navigate.push('/login');
		      // window.location.reload();
        }}
        tabIndex={0}
			>
        Logout
			</a>
  );
  }else{
    return(
      <a
          rel="noopener noreferrer"
          onClick={() => {
            navigate.push('/login');
		        window.location.reload();
          }}
          role="button"
          // onKeyDown={() => {auth.signout()}}
          tabIndex={0}
        >
          Login
        </a>
    );
  }
};

const menu = (
	<Menu>
    <Menu.Item>
      <LoggedInLink />
    </Menu.Item>
  </Menu>
);

const AccountDropdown = (props) =>{
  
  const { loggedIn } = props;
  
  if(loggedIn){
    const { givenName, lastName, roleName } = loggedIn;
    const fname = givenName === undefined ? '' : givenName;
    const lname = lastName === undefined ? '' : lastName;
    const rname = roleName === undefined ? '' : roleName;

    // if(true){
    return(
      <Dropdown overlay={menu} trigger={['click']}>
          <Button type="link" className="ant-dropdown-link">
            <div className="user-menu">
              <div className="user-menu-text">
                <Text style={{color: '#f2f2f2'}} strong >{`${fname} ${lname}`}</Text>
                <Text style={{color: '#f2f2f2'}}>{rname}</Text>
              </div>
              <div className="user-menu-avatar">
                <Avatar><UserOutlined /></Avatar>
              </div>
              <div className="user-menu-icon">
                <DownOutlined />
              </div>
            </div>
          </Button>
        </Dropdown>
    );
  }else{
    return(<></>);
  }
};

const Header = () => {
  const loggedIn = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));
  return(    
    <AntHeader className="main-header">
      <div>
        <div style={{ display: 'inline-block', width: 400 }}>
          <Row>
            <Col span={4} style={{ textAlign: 'center' }}>
              <img src={CompanyLogoWhite} alt="logo" style={{ height: 50 }} />
            </Col>
            <Col className="logo-pane">
            <Text style={{color: '#f2f2f2'}}>
              {process.env.REACT_APP_COMPANY_NAME}
              <span style={{
                fontSize: '0.75em',
                opacity: 0.7,
                marginLeft: '8px',
                fontWeight: 'normal'
              }}>
                v{process.env.REACT_APP_VERSION}
              </span>
            </Text>
            </Col>
          </Row>
        </div>
        <div style={{ float: 'right' }}>
          {/* {false && (
            <Button type="primary" shape="round" className="login-btn">
              LOGIN
            </Button>
          )}
          <UserMenu /> */}
          <AccountDropdown 
          loggedIn={loggedIn} 
          />
        </div>
      </div>
    </AntHeader>
  );
}

export default withRouter(Header);
